import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted OFL fonts (no CDN request, no tracking, works offline).
import '@fontsource/silkscreen/400.css';
import '@fontsource/silkscreen/700.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';

import './styles/tokens.css';
import './styles/base.css';
import './styles/ui.css';
import './styles/game.css';
import './styles/eggs.css';
import './styles/grove.css';
import './styles/guilds.css';
import './styles/bazaar.css';
import './styles/chat.css';
import './styles/badges.css';
import './styles/events.css';
import './styles/roles.css';
import './styles/phase3.css';
import './styles/avatars.css';
import './styles/collection.css';
import './styles/worldboss.css';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
